import React, { Component } from 'react';
import { List, Icon, Button, CircularProgress } from '@material-ui/core';
import { connect } from 'react-redux';
import CategoryItem from './CategoryItem';
import CategoryFormModal from './CategoryFormModal';
import categoryService from '../../api/categoryService';

class CategoriesScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            moreButton: null,
            showModal: false,
            categoryToEdit: null,
            loadingData: true
        };

        this.showFormModal = this.showFormModal.bind(this);
        this.hideFormModal = this.hideFormModal.bind(this);
        this.editCategory = this.editCategory.bind(this);
    }

    async componentDidMount() {
        const { categories } = this.props;
        this.setState({
            loadingData: false
        });   
    }

    showFormModal() {
        this.setState({
            showModal: true
        });
    }

    hideFormModal() {
        this.setState({
            showModal: false
        });
    }

    editCategory(category) {
        this.setState({
            categoryToEdit: category
        }, () => {
            this.showFormModal();
        });
    }

    render() {
        const { categories } = this.props;

        if (this.state.loadingData) {
            return (
                <div style={{ display: 'flex', flex: 1, flexGrow: 1, height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress color="secondary" />
                </div>
            );
        }

        return (
            <div>
                <div style={{ textAlign: 'right' }}>
                    <Button color="secondary" variant="contained" onClick={this.showFormModal}>
                        <Icon style={{ marginRight: 10 }}>add</Icon> Add new category
                    </Button>
                </div>
                <List>
                    {
                        categories.map((category) => {
                            return (
                                <CategoryItem
                                    key={category.id}
                                    category={category}
                                    subcategories={category.subcategories}
                                    editCategory={this.editCategory} />
                            );
                        })
                    }
                </List>
                <CategoryFormModal showModal={this.state.showModal}
                    hideModal={() => {
                        this.hideFormModal();
                        this.setState({
                            categoryToEdit: null
                        });
                    }}
                    categoryToEdit={this.state.categoryToEdit} />
            </div>
        );
    }
}

const mapStateToProps = store => ({
    categories: store.categoryState.categories
});

export default connect(mapStateToProps)(CategoriesScreen);